module.exports = __webpack_public_path__ + "static/loansense-f3a322c2c103a1a84e0779ef6183dacf.svg";